import styled from "styled-components";
import { CONTENT_AREA_DESKTOP } from "@common/theme";

export interface ContentAreaProps {
  width?: string;
}

const Content = styled.div<ContentAreaProps>`
  width: ${({ width }) => (width ? width : CONTENT_AREA_DESKTOP)};
  max-width: 1240px;
`;

export default Content;
